export default '/build/d293d0ad.svg'